import { Dialog, DialogActions, DialogTitle, DialogContent, Button, Typography, Grid, CircularProgress, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from '@mui/styles';
import CustomGoogleMap from "../../components/CustomGoogleMap";
import CustomGoogleMarker from "../../components/CustomGoogleMarker";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import theme from "../../theme.css";
const useStyles = makeStyles((theme) => ({
    paperXs: {
        width: 500
    },
    paperSm: {
        width: 600
    },
    paperMd: {
        width: 900
    },
    paperLg: {
        width: 1000
    },
    paperXl: {
        width: 1200
    },
    title: {
        borderBottom: '1px solid ' + theme.palette.background.primary,
        paddingBottom: theme.spacing(1),
    },
    content: {
        marginTop: theme.spacing(1)
    },
    address_item: {
        cursor: 'pointer',
        padding: theme.spacing(1),
        borderBottom: '1px solid ' + theme.palette.background.primary,
    },
    address_selected: {
        backgroundColor: theme.palette.background.primary,
    },
    list_items: {
        overflow: 'auto',
        [theme.breakpoints.down('xl')]: {
            maxHeight: '60vh',
        },
        [theme.breakpoints.down('sm')]: {
            maxHeight: '30vh',
        },
    }
}));

export default function ListAddresses(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { open, addresses, addressSelected, setAddressSelected, addressInfor, maxWidth, color } = props;
    const [location, setLocation] = useState({ lat: -34.1664276, lng: 16.6257506 });
    const [showCheckCoverage, setShowCheckCoverage] = useState(false);
    const [listAddress, setListAddress] = useState(addresses ? [...addresses] : []);
    const [showLoading, setShowLoading] = useState(false);
   
    useEffect(() => {
        if (addressInfor) {
            setLocation({
                ...addressInfor,
                lat: addressInfor.latitude,
                lng: addressInfor.longitude,
            })
        }
    }, [addressInfor])
    
    const onSelectLocation = (e) => {
        console.log("AAAA onSelectLocation e: ", e)
        let location = { lat: e.lat, lng: e.lng };
        setLocation(location)
        setShowCheckCoverage(true);
    }
   
    const onCheckCoverage = async () => {
        if (location) {
            setShowLoading(true);
            let _newAddresses = await props.onCheckCoverageLatLongV3({ latitude: location.lat, longitude: location.lng })
            setListAddress(_newAddresses);
            setShowCheckCoverage(false);
            setShowLoading(false);
        }
    }
    return (
        <Dialog
            open={open}
            maxWidth={'xl'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{
                paper: classes.paperXl,
            }}
        >
            <DialogTitle id="alert-dialog-title" color={color ? color : undefined} className={classes.title}>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item>
                        {t('please_select_address')}
                    </Grid>
                    {showCheckCoverage && <Grid item >
                        <Button color='primary' variant='contained' onClick={() => onCheckCoverage()} startIcon={showLoading && <CircularProgress size={15} style={{ color: theme.palette.common.white }} />}>{t('btn_check_coverage')}</Button>
                    </Grid>}
                </Grid>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Grid item xs={12} container spacing={1} style={{ minHeight: '70vh', overflow: 'auto' }}>
                    <Grid item xs={12} md={3}>
                        <Typography variant='subtitle1'>{t('Please select your closest address')}</Typography>
                        {showLoading ? <CustomCircularProgress /> : 
                        <div className={classes.list_items}>
                            {listAddress.length > 0 && listAddress.map((item, index) => {
                                let _hideOpenserve = document._portalConfig.hideOpenserveProducts;
                                if (_hideOpenserve && item.openserve_ref_isp) return null;

                                let mdu = "";
                                if(item.mdu_name){
                                    mdu = " - MDU: " + item.mdu_name;

                                    if(item.mdu_unitno)
                                        mdu += " " + item.mdu_unitno;
                                }

                                return (
                                    <Grid item xs={12} key={index} className={addressSelected && addressSelected.objectID === item.objectID ? classes.address_selected : null}>
                                        <Typography variant="subtitle2" className={classes.address_item} onClick={() => setAddressSelected(item)}>{item.address + mdu + ' (' + getServiceType(item.product_types) + ')'}</Typography>
                                    </Grid>
                                );
                            })}
                            {listAddress.length == 0 && <Typography variant="subtitle2" marginLeft={1}>{t('Please select another location.')}</Typography>}
                        </div>}
                        <Typography variant='subtitle1' marginTop={1}>{t('Alternatively drop a pin on the map')}</Typography>
                    </Grid>
                    <Grid item xs={12} md={9} style={{ minHeight: '20vh' }}>
                        {/* {showCheckCoverage && <Grid item xs={12} container justifyContent={'flex-end'}>
                            <Button color='primary' variant='contained' onClick={() => onCheckCoverage()} startIcon={showLoading && <CircularProgress size={15} style={{ color: theme.palette.common.white }} />}>{t('btn_check_coverage')}</Button>
                        </Grid>} */}
                        <CustomGoogleMap
                            center={{ lat: location.lat, lng: location.lng }}
                            zoom={17}
                            onClick={(e) => onSelectLocation(e)}
                            filteredMarkers={[
                                { ...location }
                            ]}
                        >
                            <CustomGoogleMarker
                                lat={location.lat}
                                lng={location.lng}
                                myPlace={{ location }}
                            />
                        </CustomGoogleMap>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                {!showCheckCoverage && <Button variant="contained" sx={{ background: color ? color : undefined }} onClick={() => props.confirmAction()}>
                    {t('btn_ok')}
                </Button>}
                <Button variant="outlined" onClick={() => props.onClose()}>
                    {t('btn_cancel')}
                </Button>
            </DialogActions>
            
        </Dialog>
    )
}

function getServiceType(productTypes) {
    let displayType = productTypes;
    if (!productTypes)
        return '';
    displayType = displayType.replace('VR', 'Vuma');
    displayType = displayType.replace('VC', 'Vuma');
    displayType = displayType.replace('OS', 'Openserve');
    displayType = displayType.replace('OC', 'Octotel');
    return displayType
}
